import { createColumnHelper } from "@tanstack/react-table";
import { Fragment, useEffect, useRef, useState } from "react";  //M10-12866
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "src/components";
import { ordActions } from "src/context/order-slice";
import { RootState } from "src/context/store";
import { usePagination } from "src/hooks/usePagination";
import { getCounterByEmployee } from "src/services/order-api";
import Table from "../../components/Table";
import Loader from "../../components/Loader";
import { useToast } from "src/hooks/useToast";
import { getCounterTypes } from "src/services/common-api";  //M10-12866

const columnHelper = createColumnHelper();



const OrdersHomeScreen = () => {
  const [loading, setLoading] = useState(false);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const { counterData, selectedModule } = useSelector((state: RootState) => state.ord || []); //M10-12866
  const { pagination, onPaginationChange, pageIndex, pageSize, resetPagination } = usePagination();
  const [search, setSearch] = useState("");
  const [isRetrieve, setIsRetrieve] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [moduleTypes, setModuleTypes] = useState<any>() //M10-12866

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { toast } = useToast();
  // M10-12866
  const columns = [
    columnHelper.accessor("counter_code", {
      cell: (info) => info.getValue(),
      header: () => "Counter Code",
      enableSorting: true,
    }),
    columnHelper.accessor("counter_name", {
      cell: (info) => info.getValue(),
      header: () => "Counter Name",
      enableSorting: true,
    }),
    columnHelper.accessor("location_name", {
      cell: (info) => info.getValue(),
      header: () => "Location Name",
      enableSorting: true,
    }),

    columnHelper.accessor("dr_ph_lnk_code", {
      cell: (info) => info.getValue(),
      header: () => "Link Type Code",
      enableSorting: true,
    }),
    columnHelper.accessor("company_name", {
      cell: (info) => info.getValue(),
      header: () => "Company",
      enableSorting: true,
    }),
    ...(selectedModule !== 4
      ? [
        columnHelper.accessor("pharmacist_counter_name", {
          cell: (info) => info.getValue(),
          header: () => "Pharmacy Name",
          enableSorting: true,
        }),
        columnHelper.accessor("pharmacist_counter_code", {
          cell: (info) => info.getValue(),
          header: () => "Pharmacy Code",
          enableSorting: true,
        }),
      ]
      : []),
    // columnHelper.accessor("division_name", {
    //   cell: (info) => info.getValue(),
    //   header: () => "Division",
    //   enableSorting: true,
    // }),
  ];
  const latestRequestModule = useRef<string | null>(null);  //M10-12866
  //M10-12866
  const fetchCounters = async (moduleCode?: string) => {
    if (!moduleCode) return;
    latestRequestModule.current = moduleCode; // Track latest request
    window.sessionStorage.setItem("iSalesRequired", "");
    dispatch(ordActions.setOrderStockists([]));
    try {
      setLoading(true);
      let query = "?";
      if (search) {
        query += `&search=${search.trim()}`;
      }
      query += `&limit=${pageSize}&page=${pageIndex}`;
      if (moduleCode) query += `&module_code=${moduleCode}`;
      query = query.replace("?&", "?");
      query = query.replace("&&", "&");

      const response = await getCounterByEmployee(query);

      if (latestRequestModule.current === moduleCode) {
        setTotalRowCount(response?.data?.totalCount);
        dispatch(ordActions.setCounterData(response?.data?.data));
        window.sessionStorage.setItem("counterCompanyLocationId", response?.data?.data?.[0]?.counter_company_location_id);
      }
    } catch (error: any) {
      if (latestRequestModule.current === moduleCode) {
        toast({ description: error?.response?.data?.message || "Failed to fetch counters", variant: "destructive" })
        console.error("Failed to fetch counters", error);
      }
    } finally {
      if (latestRequestModule.current === moduleCode) setLoading(false);
    }
  };
  //M10-12866
  const rowClickHandler = async (row: any) => {
    const query = `?counter_company_location_id=${row?.original?.countercompanylnk_id}&stockist=true`;
    window.sessionStorage.setItem("counterOrderId", row?.original?.counter_code);
    window.sessionStorage.setItem("kam_price_visibility", row?.original?.kam_price_visibility); //M10-12866
    window.sessionStorage.removeItem("order_id_int");
    dispatch(ordActions.setOrderDetailsFiltered([]));
    try {
      setIsLoading(true);
      const response = await getCounterByEmployee(query);
      dispatch(ordActions.setSelectedCounterData(response?.data?.data?.[0]));
      window.sessionStorage.setItem("counterCompanyLocationId", row?.original?.countercompanylnk_id);
    } catch (err: any) {
      toast({ description: err?.response?.data?.message || "Failed to fetch counter data", variant: "destructive" })
      console.error("Failed to fetch counter data", err);
    } finally {
      setIsLoading(false);
    }
    navigate(`/transactions/orders/details/${row?.original?.counter_code}/0`);
    dispatch(ordActions.setSelectedCounter(row?.original));
  };

  const handleSearch = (searchQuery: string) => {
    setSearch(searchQuery);
    resetPagination();
  };

  let timerId: any;
  useEffect(() => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      if (isRetrieve) {
        resetPagination();
        fetchCounters(selectedModule);  //M10-12866
      }
    }, 300);

    return () => clearTimeout(timerId);
  }, [search]);

  let pageCount = Math.ceil(totalRowCount / (pageSize ?? 1));

  //M10-12866
  const fetchModuleTypes = async () => {
    try {
      const response = await getCounterTypes("?PUC=true");
      const counterTypes = response?.data?.data || [];

      setModuleTypes(counterTypes);
      // setSelectedModule(counterTypes?.[0]?.module_code)
      dispatch(ordActions.setSelectedModule(counterTypes?.[0]?.module_code));
      // fetchCounters(counterTypes?.[0]?.module_code)   // M10-13265
      setIsRetrieve(true);
    } catch (error) {
      console.error("Error fetching API data:", error);
    }
  };
  useEffect(() => {
    fetchModuleTypes()
  }, [])
  //M10-12866
  // useEffect(() => {
  //   if (isRetrieve) {
  //     fetchCounters();
  //   }
  // }, [pageIndex]);
  // M10-12866
  useEffect(() => {
    if (!isRetrieve) return; // ⛔ skip until Retrieve is clicked

    fetchCounters(selectedModule);  // M10-13265
    dispatch(ordActions.setCounterData([]));  // M10-13265
  }, [pageIndex, pageSize]);
  // M10-12866

  if (isLoading) {
    return <Loader />;
  }

  return (
    //M10-12866
    <Fragment>
      {/* Module display line */}
      <div className="bg-white border-b px-6 py-4 mb-4 flex justify-between items-center">
        {/* Left: Module pills */}
        <div className="flex gap-2 flex-wrap">
          {moduleTypes?.map((module: any) => {
            const isSelected = selectedModule === module.module_code; // or module_desc if module_code not available
            return (
              <span
                key={module.module_code}
                onClick={() => {
                  dispatch(ordActions.setSelectedModule(module.module_code));
                  setIsRetrieve(true);
                  dispatch(ordActions.setCounterData([]));  // M10-13265
                  // fetchCounters(module?.module_code);  // M10-13265
                  resetPagination();  //M10-12866
                }// pass module_code to API

                } // select on click
                className={`
  px-4 py-2 text-sm font-medium rounded-lg cursor-pointer transition
  ${isSelected
                    ? 'bg-purple-700 text-white shadow'
                    : 'bg-purple-100 text-purple-700 hover:bg-purple-200'} 
`}
              >
                {module?.module_desc}
              </span>
            );
          })}
        </div>

        {/* Right: Search + Retrieve */}
        <div className="flex gap-2 items-center">
          <Input
            debounceTime={500}
            placeholder="Search by counter"
            className="w-full rounded-xl h-10" // limit width
            showIcon={false}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e: any) => {
              if (e.key === "Enter") {
                setIsRetrieve(true);
                fetchCounters(selectedModule);
              }
            }}
          />
          <Button
            onClick={() => {
              setIsRetrieve(true);
              fetchCounters(selectedModule);
            }}
            loaderSize="small"
            className="h-auto py-2 border"
          >
            Retrieve
          </Button>
        </div>
      </div>


      {/* Conditional rendering */}
      {
        !isRetrieve ? (
          <div className="pt-40 mt-2 text-center text-gray-500">
            No data loaded. Click Retrieve to fetch data.
          </div>
        ) : (
          <Table
            columns={columns}
            title="Counters"
            subtitle="View and manage counters"
            data={counterData ?? []}
            onRowClick={rowClickHandler}
            isLoading={loading}
            isGlobalSearch={true}
            showSearch={false}
            manualPagination={true}
            pageCount={pageCount}
            pagination={pagination}
            onPaginationChange={onPaginationChange}
            onGlobalSearch={handleSearch}
          />
        )
      }
    </Fragment >
    //M10-12866
  );
};

export default OrdersHomeScreen;
